import { TermosUsoRepository } from "../repository/termos_uso_repository";

export class TermosUsoService {
	constructor() {
		this.termosUsoRepository = new TermosUsoRepository();
	}

	async getLatest() {
		return await this.termosUsoRepository.getLatest();
	}

	async checkAcceptance(termoId) {
		return await this.termosUsoRepository.checkAcceptance(termoId);
	}

	async accept(termoId) {
		return await this.termosUsoRepository.accept(termoId);
	}
}
